<template>
  <v-btn small :loading="loading" :disabled="loading || !artworks.length" @click="download">
    <v-icon small class="mr-2">mdi-microsoft-excel</v-icon>Text review Excel
    <span v-if="loading && total" class="ml-2">{{ completed }}/{{ total }}</span>
  </v-btn>
</template>

<script>
import XLSX from 'xlsx'
import { htmlToPlainText, loadTextReviewData } from '@/utils/textReviewExport'

export default {
  props: { artworks: { type: Array, default: () => [] } },
  data: () => ({ loading: false, completed: 0, total: 0 }),
  methods: {
    async download() {
      this.loading = true
      this.completed = 0
      this.total = this.artworks.reduce((count, artwork) => count + (artwork.artwork_texts || []).length, 0)
      try {
        const review = await loadTextReviewData(
          this.artworks,
          this.$globals.apiserver,
          completed => { this.completed = completed }
        )
        const rows = [[
          'Row type', 'Artwork ID', 'Artist', 'Artwork title', 'Accession number',
          'Text status', 'Text title', 'Public', 'Text', 'Edit text',
        ]]
        const links = []

        review.forEach(entry => {
          const artwork = entry.artwork
          rows.push([
            'Artwork', artwork.id, artwork.full_name || artwork.name || artwork.artist_name || '',
            htmlToPlainText(artwork.title), artwork.accession_number || '', entry.status,
            '', '', '', '',
          ])
          if (entry.texts.length === 0) {
            rows.push(['Text', '', '', '', '', 'No text', '', '', 'No text', ''])
          } else {
            entry.texts.forEach(text => {
              rows.push([
                'Text', '', '', '', '', '', text.given_filename || text.title || 'Untitled text',
                text.isPublic ? 'Yes' : 'No', htmlToPlainText(text.content), 'Edit text',
              ])
              links.push({ row: rows.length - 1, url: text.editUrl })
            })
          }
        })

        const sheet = XLSX.utils.aoa_to_sheet(rows)
        sheet['!cols'] = [
          { wch: 12 }, { wch: 12 }, { wch: 28 }, { wch: 35 }, { wch: 18 },
          { wch: 22 }, { wch: 35 }, { wch: 10 }, { wch: 90 }, { wch: 16 },
        ]
        links.forEach(link => {
          const address = XLSX.utils.encode_cell({ r: link.row, c: 9 })
          sheet[address].l = { Target: link.url, Tooltip: 'Open text editor in CMS' }
        })
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, sheet, 'Artwork texts')
        XLSX.writeFile(workbook, `artwork-text-review-${new Date().toISOString().slice(0, 10)}.xlsx`)
      } catch (error) {
        this.$emit('error', 'Text review Excel could not be generated.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/lists/TextReviewExcel.vue